import React, { useContext, useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    createStyles,
    Divider,
    Grid,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { ToastMessageContext } from "lib/contexts/message_context";
import LoadingIndicator from "components/universal/loading_indicator";
import UserProfileHeader from "./UserProfileHeader";
import { TabSectionBar } from "components/tab_component";
import Training from "./Training";
import Authorization from "./Authorization";
import Recency from "./Recency";
import { getComplianceAlertClass } from "../../../lib/utils/complianceColorHelper";


const useStyles = makeStyles((theme) =>
    createStyles({
        modal: {
            "& .MuiDialog-paperWidthSm": {
                minWidth: "850px",
            },
        },
        container: {
            padding: "50px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
        },





    })
);

function ManageUserCompliance(props) {
    const { handleClose, currentSelection, id, tab = "home" } = props;
    const classes = useStyles();
    const message = useContext(ToastMessageContext);
    const [currentTab, setCurrentTab] = useState(0);
    const [Loading, setLoading] = useState(false);
    const [statusColor, setStatusColor] = useState();
    const [statusTextColor, setStatusTextColor] = useState("black");
    const [text, setText] = useState();

    // Fetch data
    useEffect(() => {
        if (!id || tab === "operation") return;

        setLoading(true);

        const record = currentSelection;
        if (record?.color) {
            const alertClass = getComplianceAlertClass(record.color);
            // Map Alert class names to UserProfileHeader class names
            const classNameMap = {
                errorAlert: 'error',
                amberAlert: 'amber',
                successAlert: 'success',
                whiteAlert: 'white'
            };
            setStatusTextColor(classNameMap[alertClass] || 'white');
        }
        setText(record?.message);
        setLoading(false);

    }, [id, currentSelection]);
    const navMenu = [
        { label: <div>Training &nbsp;&nbsp;</div> },
        { label: <div>Competency &nbsp;&nbsp;</div> },
        { label: <div>Authorisation &nbsp;&nbsp;</div> },
        { label: <div>Recency &nbsp;&nbsp;</div> },


    ];
    return (
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className={classes.modal}
        >
            <div className={classes.container}>
                {Loading ? (
                    <LoadingIndicator />
                ) : (
                    <>
                        {tab === "home" ? <UserProfileHeader
                            profileImage={currentSelection?.profile_img}
                            statusColor={statusColor}
                            text={text}
                            statusTextColor={statusTextColor}
                            base={currentSelection?.base_station}
                            userName={currentSelection?.user_name}
                        /> : <span>{" "}</span>}

                        <TabSectionBar
                            {...props}
                            tabProperties={navMenu}
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                            isGettingDetails={false}
                        />
                        <Divider style={{ paddingBottom: "1px" }} />
                        {currentTab === 0 &&
                            <Training {...props}
                                title={"Training"}
                                section={"complianceTraining"}
                                handleCloseUpdateExp={handleClose}
                                id={id} />}
                        {currentTab === 1 &&
                            <Training
                                {...props}
                                title={"Competency"}
                                section={"complianceCompetency"} />

                        }
                        {currentTab === 2 &&
                            <Authorization
                                currentSelection={currentSelection}
                                id={id} />
                        }
                        {currentTab === 3 &&
                            <Recency
                                currentSelection={currentSelection}
                                id={id} />
                        }
                    </>
                )}
            </div>
        </Dialog>
    );
}

export default ManageUserCompliance;
